const initialState = {
   cases:[],
   accountdetails:[],
    
  
  };
  
  const PatientReportsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, cases:action.payload};
            case 'FETCH_DATA_SUCCESS':
            return {... state, accountdetails:action.payload};
            
            
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default PatientReportsReducers;
  
  